import React, { useEffect, useMemo, useRef } from 'react';

import { activeCustomReportConfig } from 'c-components/HiddenReport/Custom/activeCustomReportConfig';
import {
    getCustomReportConfigFromQuery,
    shouldAutoPrintCustomReport,
} from 'c-components/HiddenReport/Custom/customReportPreview';
import type { Payload as HiddenReportPayload } from 'c-components/HiddenReport/HiddenReport';
import { useCustomReportData } from 'c-components/HiddenReport/Custom/customReportData';
import {
    customReportStyles,
    renderCustomSlides,
} from 'c-components/HiddenReport/Custom/customReportSlides';

const CustomReport: React.FC<{ payload: HiddenReportPayload }> = ({ payload }) => {
    const previewConfig = useMemo(() => getCustomReportConfigFromQuery(), []);
    const reportConfig = previewConfig ?? activeCustomReportConfig;
    const shouldAutoPrint = useMemo(() => shouldAutoPrintCustomReport(), []);
    const hasTriggeredPrintRef = useRef(false);
    const { data } = useCustomReportData(payload, reportConfig.slides);

    useEffect(() => {
        // eslint-disable-next-line no-underscore-dangle
        (window as any).__CUSTOM_REPORT_CONFIG__ = reportConfig;
    }, [reportConfig]);

    useEffect(() => {
        let timeout: number | null = null;

        if (shouldAutoPrint && data && !hasTriggeredPrintRef.current) {
            hasTriggeredPrintRef.current = true;

            timeout = window.setTimeout(() => {
                window.print();
            }, 350);
        }

        return () => {
            if (timeout != null) {
                window.clearTimeout(timeout);
            }
        };
    }, [data, shouldAutoPrint]);

    return (
        <>
            <style>{customReportStyles}</style>
            {renderCustomSlides({
                report: data,
                slides: reportConfig.slides,
                campaignId: payload.campaign_id,
                use12hHourFormat: reportConfig.use12hHourFormat,
            })}
        </>
    );
};

export default CustomReport;
